import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import login from './modules/login';
import fsm from './modules/fsm/index';

Vue.use(Vuex);

// if (!process || (process.env.NODE_ENV !== 'test')) {
//   let sessionJson = JSON.parse(window.sessionStorage.getItem('vuex'))
//   sessionJson['login']['watch']['externalMeasuresLoaded'] = false
//   window.sessionStorage.setItem('vuex', JSON.stringify(sessionJson))
// }

// console.log(JSON.parse(window.sessionStorage.getItem('vuex'))['login'][['watch']])

export default new Vuex.Store({
  modules: {
    login,
    fsm
  },
  plugins: [
    createPersistedState({storage: window.sessionStorage,paths:[
      'login.loggedIn',
      'login.cda',
      'login.csrf',
      'login.pdf',
      'login.report',
      'login.phrData.impersonation',
      'login.phrData.patient',
      'login.phrData.administrator',
      'login.phrData.recent',
      'login.phrData.genders',
      'login.phrData.medicalDeviceSources',
      'login.phrData.pdfs',
      'login.phrData.relationDescriptions',
      'login.phrData.relationNatures',
      'login.phrData.reports',
      'login.phrData.suffixes',
      'login.phrData.taxonomies',
      'login.phrData.titles',
      'login.phrData.user',
      'login.provider',
      'login.sessionId',
      'login.watch',
      'login.phrData.phoneTypes',
      'login.phrData.states',
      'login.phrData.meters',
      'login.preferences.daysOfVitalsShown'
    ]})
  ]
});
